/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbVisiteFormateurGridDto
 */
export interface FcbVisiteFormateurGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbVisiteFormateurGridDto
     */
    formateur?: string | null;
}

/**
 * Check if a given object implements the FcbVisiteFormateurGridDto interface.
 */
export function instanceOfFcbVisiteFormateurGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbVisiteFormateurGridDtoFromJSON(json: any): FcbVisiteFormateurGridDto {
    return FcbVisiteFormateurGridDtoFromJSONTyped(json, false);
}

export function FcbVisiteFormateurGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbVisiteFormateurGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'formateur': !exists(json, 'formateur') ? undefined : json['formateur'],
    };
}

export function FcbVisiteFormateurGridDtoToJSON(value?: FcbVisiteFormateurGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'formateur': value.formateur,
    };
}

